import { useDBScanStore } from '../dal/db-scan-store';
import { getPointTypeName, getTableData } from '../domain/db-scan-provider';

const Table = () => {

    const params = useDBScanStore(store => store.params);
    const distance = useDBScanStore(store => store.distance);

    const {
        map,
        mapCalculations,
        clusterMap,
        pointTypesMap,
        clusters,
    } = getTableData(params, distance);

    return (
        <div className="flex gap-4 items-start">
            <table className="mr-6">
                <thead>
                <tr>
                    <td className="border p-4 bg-slate-100 border-slate-200">&nbsp;</td>
                    {
                        params.points.map((point, pi) => {
                            return (
                                <td
                                    className="border p-4 bg-slate-100 border-slate-200"
                                    key={ `point-${ pi }` }>
                                    { point[0] }
                                </td>
                            )
                        })
                    }
                </tr>
                </thead>
                <tbody>
                {
                    params.points.map((point1, pi1) => {
                        return (
                            <tr key={ `point-${ pi1 }` }>
                                <td className="border p-4 bg-slate-100 b-slate-200">
                                    { point1[0] }
                                </td>

                                {
                                    params.points.map((point2, pi2) => {

                                        return (
                                            <td
                                                className={ `border p-4 border-slate-200 ${ pi1 === pi2 ? 'bg-slate-100' : 'bg-white' }` }
                                                key={ `p-p-${ pi2 }` }>
                                                { map.get(point1[0] + '-' + point2[0]) }
                                            </td>
                                        )
                                    })
                                }
                            </tr>
                        )
                    })
                }
                </tbody>
            </table>

            <div className="flex flex-col mr-6">
                <strong className="mb-2">Calculations:</strong>
                {
                    mapCalculations.map((calculation, i) => {
                        return (
                            <div key={ `calc-${ i }` } className="border-b">
                                { calculation }
                            </div>
                        )
                    })
                }
            </div>

            <div className="flex flex-col mr-6">
                <strong className="mb-2">נקודות בסביבת אפסילון:</strong>
                {
                    params.points.map((point, pi) => {

                        const set = clusterMap.get(point[0]);

                        return (
                            <div key={ `point-${ pi }` } className="border-b">
                                <strong>{ point[0] }</strong>: { [...set].join(', ') }
                                &nbsp; - <strong>{ getPointTypeName(pointTypesMap.get(point[0])) }</strong>
                            </div>
                        )
                    })
                }
            </div>

            <div className="flex flex-col mr-6">
                <strong className="mb-2">Clusters</strong>
                {
                    clusters.map((cluster, cl) => {
                        return (
                            <div key={ `cluster-${ cl }` } className="border-b">
                                { cluster.join(', ') }
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
};

export default Table;